const sendAnalytic =  (category, action, label = '') => {
    /* eslint-disable */
    if (typeof window === 'undefined' || !Array.isArray(window._piq)) {
        return;
    }

    window._piq.push(['trackEvent', category, action, label]);
}

export default sendAnalytic;
